import { imConnectListener } from './imConnectListener'
import { imReviceMessageListener } from './imReciveMessageListener'

// 挂载IM相关监听回调
export const mountAllEMListener = () => {
    // 监听连接环信
    const { mountConnectEventListener } = imConnectListener()
    mountConnectEventListener()
    // 监听收到消息
    const { mountReviceMessageEventListener } = imReviceMessageListener()
    mountReviceMessageEventListener()
}
export {
    imConnectListener,
    imReviceMessageListener,
}
